
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Zap, User, Building, ArrowUpRight, BarChart3 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

interface ConsumerSummaryCardProps {
  onViewAllClick: () => void;
}

const ConsumerSummaryCard: React.FC<ConsumerSummaryCardProps> = ({ onViewAllClick }) => {
  return (
    <Card className="col-span-1">
      <CardHeader>
        <CardTitle>Consumer Summary</CardTitle>
        <CardDescription>Overview of all energy consumers</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-between border-b pb-4">
            <div className="flex items-center">
              <div className="rounded-full bg-blue-100 p-2 mr-3">
                <Building className="h-4 w-4 text-blue-600" />
              </div>
              <div>
                <p className="text-sm font-medium">Total Facilities</p>
                <p className="text-2xl font-bold">36</p>
              </div>
            </div>
            <Badge variant="outline" className="ml-auto">+5 new</Badge>
          </div>
          
          <div className="flex items-center justify-between border-b pb-4">
            <div className="flex items-center">
              <div className="rounded-full bg-blue-100 p-2 mr-3">
                <User className="h-4 w-4 text-blue-600" />
              </div>
              <div>
                <p className="text-sm font-medium">Active Consumers</p>
                <p className="text-2xl font-bold">2,847</p>
              </div>
            </div>
            <Badge variant="outline" className="ml-auto">+126 new</Badge>
          </div>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="rounded-full bg-blue-100 p-2 mr-3">
                <BarChart3 className="h-4 w-4 text-blue-600" />
              </div>
              <div>
                <p className="text-sm font-medium">Avg. Monthly Usage</p>
                <p className="text-2xl font-bold">745 kWh</p>
              </div>
            </div>
            <Badge variant="outline" className="ml-auto">+3.8%</Badge>
          </div>
        </div>
        
        <Button 
          variant="outline" 
          className="w-full mt-6 text-sm"
          onClick={onViewAllClick}
        >
          View All Consumer Data
          <ArrowUpRight className="ml-2 h-4 w-4" />
        </Button>
      </CardContent>
    </Card>
  );
};

export default ConsumerSummaryCard;
